import React, { useEffect, useState, useRef } from 'react';
import Layout from './components/Layout';
import ResponsiveShadow from './components/ResponsiveShadow';
import axios from 'axios';
import { API_BASE_URL } from '../config/ApiConfig';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import CEPMaskInput from './components/masks/CEPMaskInput';
import CelularMaskInput from './components/masks/CelularMaskInput';
import { formatCEP, unformatCEP } from './utils/cepUtils';
import { formatCPF, isValidCPF, unformatCPF } from './utils/cpfUtils';
import { formatCelular, unformatCelular } from './utils/celularUtils';
import CPFMaskInput from './components/masks/CPFMaskInput';
import useDefaultModal from './components/hooks/useDefaultModal';
import DefaultModal from './components/modals/DefaultModal';
import PageHeader from './components/PageHeader';
import PageContent from './components/PageContent';

// Certifique-se de que o CSS para .full-screen-div ainda está sendo importado
// .full-screen-div { display: flex; flex-direction: column; min-height: 100vh; }

const Pessoa = () => {
  // ... todo o seu state, useEffects e funções (NÃO MUDA NADA AQUI) ...
  const [formData, setFormData] = useState({
    cnpjEscola: '',
    cpf: '',
    nome: '',
    sexo: '',
    estadoCivil: '',
    rgNum: '',
    rgEmissor: '',
    rgDataEmissao: '',
    rgUf: '',
    nacionalidade: '',
    profissao: '',
    celular: '',
    email: '',
    cargoDiretoria: '',
    cargoDeliberativo: '',
    cargoFiscal: '',
    logrNome: '',
    logrNum: '',
    logrCompl: '',
    logrBairro: '',
    logrCep: '',
    logrCidade: '',
    logrUf: '',
  });
  const [cpfError, setCpfError] = useState('');
  const [ufs, setUfs] = useState([]);
  const [ufRg, setUfRg] = useState([]);
  const [cidades, setCidades] = useState([]);
  const [emissor, setEmissor] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const token = localStorage.getItem('token');
  const cnpj = localStorage.getItem('cnpj');
  const { setDefaultModal, showDefaultModal } = useDefaultModal();
  const refs = useRef({}); // For CEPMaskInput ref

  useEffect(() => {
    axios
      .get(`${API_BASE_URL.EMISSOR}/all`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(result => {
        setEmissor(result.data);
      })
      .catch(error => {
        console.error('Erro ao obter listas Emissor:', error);
      });
    axios
      .get(`${API_BASE_URL.UF}/all`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(result => {
        setUfRg(result.data);
        setUfs(result.data);
      })
      .catch(error => {
        console.error('Erro ao obter listas UF:', error);
      });

    if (location.state && location.state.pessoa) {
      // Ensure default empty strings for new fields if not present in pessoa
      const pessoaData = {
        cargoDiretoria: '',
        cargoDeliberativo: '',
        cargoFiscal: '',
        rgDataEmissao: '',
        celular: '',
        email: '',
        ...location.state.pessoa,
        // Garantir que todos os campos sejam sempre strings, mesmo que venham como null
        cnpjEscola: location.state.pessoa.cnpjEscola || '',
        cpf: location.state.pessoa.cpf || '',
        nome: location.state.pessoa.nome || '',
        sexo: location.state.pessoa.sexo || '',
        estadoCivil: location.state.pessoa.estadoCivil || '',
        rgNum: location.state.pessoa.rgNum || '',
        rgEmissor: location.state.pessoa.rgEmissor || '',
        rgDataEmissao: location.state.pessoa.rgDataEmissao || '',
        rgUf: location.state.pessoa.rgUf || '',
        nacionalidade: location.state.pessoa.nacionalidade || '',
        profissao: location.state.pessoa.profissao || '',
        celular: location.state.pessoa.celular || '',
        email: location.state.pessoa.email || '',
        cargoDiretoria: location.state.pessoa.cargoDiretoria || '',
        cargoDeliberativo: location.state.pessoa.cargoDeliberativo || '',
        cargoFiscal: location.state.pessoa.cargoFiscal || '',
        logrNome: location.state.pessoa.logrNome || '',
        logrNum: location.state.pessoa.logrNum || '',
        logrCompl: location.state.pessoa.logrCompl || '',
        logrBairro: location.state.pessoa.logrBairro || '',
        logrCep: location.state.pessoa.logrCep || '',
        logrCidade: location.state.pessoa.logrCidade || '',
        logrUf: location.state.pessoa.logrUf || '',
      };
      setFormData(prev => ({ ...prev, ...pessoaData, cnpjEscola: cnpj }));
    } else {
      setFormData(prev => ({ ...prev, cnpjEscola: cnpj }));
    }
  }, [location.state, token, cnpj]);

  useEffect(() => {
    if (formData.logrUf) {
      axios
        .get(`${API_BASE_URL.MUNICIPIO}/uf/${formData.logrUf}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then(result => {
          setCidades(result.data);
        })
        .catch(error => {
          console.error('Erro ao carregar cidades:', error);
        });
    } else {
      setCidades([]);
    }
  }, [formData.logrUf, token]);

  const handleChange = e => {
    const { name, value } = e.target;

    // Campos que NÃO devem ser convertidos para maiúsculas
    const excludeFromUppercase = [
      'cpf',
      'logrCep',
      'rgNum',
      'logrNum',
      'rgDataEmissao',
      'celular',
      'email',
    ]; // Adicione outros se necessário

    const processedValue = excludeFromUppercase.includes(name)
      ? value
      : typeof value === 'string'
      ? value.toUpperCase()
      : value;

    if (name === 'sexo') {
      setFormData(prevFormData => ({
        ...prevFormData,
        [name]: processedValue,
        estadoCivil: '',
        nacionalidade: '',
      }));
    } else {
      setFormData(prevFormData => ({
        ...prevFormData,
        [name]: processedValue,
      }));
    }
  };

  const getEstadoCivilOptions = () => {
    const isFeminino = formData.sexo === 'FEMININO';
    return [
      {
        value: isFeminino ? 'CASADA' : 'CASADO',
        label: isFeminino ? 'CASADA' : 'CASADO',
      },
      {
        value: isFeminino ? 'DIVORCIADA' : 'DIVORCIADO',
        label: isFeminino ? 'DIVORCIADA' : 'DIVORCIADO',
      },
      {
        value: isFeminino ? 'SOLTEIRA' : 'SOLTEIRO',
        label: isFeminino ? 'SOLTEIRA' : 'SOLTEIRO',
      },
      {
        value: isFeminino ? 'VIÚVA' : 'VIÚVO',
        label: isFeminino ? 'VIÚVA' : 'VIÚVO',
      },
    ];
  };

  const getNacionalidadeOptions = () => {
    const isFeminino = formData.sexo === 'FEMININO';
    return [
      {
        value: isFeminino ? 'BRASILEIRA' : 'BRASILEIRO',
        label: isFeminino ? 'BRASILEIRA' : 'BRASILEIRO',
      },
      {
        value: isFeminino ? 'NATURALIZADA' : 'NATURALIZADO',
        label: isFeminino ? 'NATURALIZADA' : 'NATURALIZADO',
      },
      {
        value: isFeminino ? 'ESTRANGEIRA' : 'ESTRANGEIRO',
        label: isFeminino ? 'ESTRANGEIRA' : 'ESTRANGEIRO',
      },
    ];
  };

  const getCargoDiretoriaOptions = () => {
    const isFeminino = formData.sexo === 'FEMININO';
    return [
      { value: 'PRESIDENTE', label: 'PRESIDENTE' },
      { value: 'VICE-PRESIDENTE', label: 'VICE-PRESIDENTE' },
      {
        value: isFeminino ? 'SECRETÁRIA' : 'SECRETÁRIO',
        label: isFeminino ? 'SECRETÁRIA' : 'SECRETÁRIO',
      },
      {
        value: isFeminino ? 'TESOUREIRA' : 'TESOUREIRO',
        label: isFeminino ? 'TESOUREIRA' : 'TESOUREIRO',
      },
    ];
  };

  const getCargoDeliberativoOptions = () => {
    const isFeminino = formData.sexo === 'FEMININO';
    return [
      { value: 'PRESIDENTE', label: 'PRESIDENTE' },
      {
        value: isFeminino ? 'SECRETÁRIA' : 'SECRETÁRIO',
        label: isFeminino ? 'SECRETÁRIA' : 'SECRETÁRIO',
      },
      {
        value: isFeminino ? 'CONSELHEIRA' : 'CONSELHEIRO',
        label: isFeminino ? 'CONSELHEIRA' : 'CONSELHEIRO',
      },
      { value: 'MEMBRO EFETIVO', label: 'MEMBRO EFETIVO' },
      { value: 'MEMBRO SUPLENTE', label: 'MEMBRO SUPLENTE' },
    ];
  };

  const getCargoFiscalOptions = () => {
    return [
      { value: 'MEMBRO EFETIVO', label: 'MEMBRO EFETIVO' },
      { value: 'MEMBRO SUPLENTE', label: 'MEMBRO SUPLENTE' },
    ];
  };
  useEffect(() => {
    if (!formData.sexo) return;

    setFormData(prev => {
      const currentValidDiretoriaValues = getCargoDiretoriaOptions().map(
        opt => opt.value
      );
      const currentValidDeliberativoValues = getCargoDeliberativoOptions().map(
        opt => opt.value
      );
      let changed = false;
      const updatedState = { ...prev };

      if (
        prev.cargoDiretoria &&
        !currentValidDiretoriaValues.includes(prev.cargoDiretoria)
      ) {
        updatedState.cargoDiretoria = '';
        changed = true;
      }
      if (
        prev.cargoDeliberativo &&
        !currentValidDeliberativoValues.includes(prev.cargoDeliberativo)
      ) {
        updatedState.cargoDeliberativo = '';
        changed = true;
      }
      return changed ? updatedState : prev;
    });
  }, [formData.sexo]);
  useEffect(() => {
    setFormData(prev => {
      const updatedState = { ...prev };
      let changed = false;

      if (prev.cargoDiretoria) {
        if (updatedState.cargoFiscal !== '') {
          updatedState.cargoFiscal = '';
          changed = true;
        }

        const isFeminino = prev.sexo === 'FEMININO';
        let validDeliberativoValues;

        if (prev.cargoDiretoria === 'PRESIDENTE') {
          validDeliberativoValues = ['PRESIDENTE'];
        } else if (
          prev.cargoDiretoria === (isFeminino ? 'SECRETÁRIA' : 'SECRETÁRIO')
        ) {
          validDeliberativoValues = [isFeminino ? 'SECRETÁRIA' : 'SECRETÁRIO'];
        } else if (
          ['VICE_PRESIDENTE', 'TESOUREIRO', 'TESOUREIRA'].includes(
            prev.cargoDiretoria
          )
        ) {
          validDeliberativoValues = [];
        } else {
          validDeliberativoValues = getCargoDeliberativoOptions().map(
            o => o.value
          );
        }

        if (
          prev.cargoDeliberativo &&
          !validDeliberativoValues.includes(prev.cargoDeliberativo)
        ) {
          updatedState.cargoDeliberativo = '';
          changed = true;
        }
      }
      return changed ? updatedState : prev;
    });
  }, [formData.cargoDiretoria, formData.sexo]);

  // useEffect for cargoDeliberativo changes
  useEffect(() => {
    setFormData(prev => {
      const updatedState = { ...prev };
      let changed = false;

      if (prev.cargoDeliberativo) {
        if (updatedState.cargoFiscal !== '') {
          updatedState.cargoFiscal = '';
          changed = true;
        }

        const isFeminino = prev.sexo === 'FEMININO';
        let validDiretoriaValues;

        if (prev.cargoDeliberativo === 'PRESIDENTE') {
          validDiretoriaValues = ['PRESIDENTE'];
        } else if (
          prev.cargoDeliberativo === (isFeminino ? 'SECRETÁRIA' : 'SECRETÁRIO')
        ) {
          validDiretoriaValues = [isFeminino ? 'SECRETÁRIA' : 'SECRETÁRIO'];
        } else if (
          [
            'CONSELHEIRO',
            'CONSELHEIRA',
            'MEMBRO EFETIVO',
            'MEMBRO SUPLENTE',
          ].includes(prev.cargoDeliberativo)
        ) {
          validDiretoriaValues = [];
        } else {
          validDiretoriaValues = getCargoDiretoriaOptions().map(o => o.value);
        }

        if (
          prev.cargoDiretoria &&
          !validDiretoriaValues.includes(prev.cargoDiretoria)
        ) {
          updatedState.cargoDiretoria = '';
          changed = true;
        }
      }
      return changed ? updatedState : prev;
    });
  }, [formData.cargoDeliberativo, formData.sexo]);

  useEffect(() => {
    setFormData(prev => {
      if (prev.cargoFiscal) {
        if (prev.cargoDiretoria !== '' || prev.cargoDeliberativo !== '') {
          return { ...prev, cargoDiretoria: '', cargoDeliberativo: '' };
        }
      }
      return prev;
    });
  }, [formData.cargoFiscal]);

  const getFilteredCargoDiretoriaOptions = () => {
    const { cargoDeliberativo, sexo, cargoFiscal } = formData;
    if (cargoFiscal) return [];

    const allOptions = getCargoDiretoriaOptions();
    if (cargoDeliberativo === 'PRESIDENTE')
      return allOptions.filter(opt => opt.value === 'PRESIDENTE');
    if (
      cargoDeliberativo === (sexo === 'FEMININO' ? 'SECRETÁRIA' : 'SECRETÁRIO')
    )
      return allOptions.filter(
        opt => opt.value === (sexo === 'FEMININO' ? 'SECRETÁRIA' : 'SECRETÁRIO')
      );
    if (
      [
        'CONSELHEIRO',
        'CONSELHEIRA',
        'MEMBRO EFETIVO',
        'MEMBRO SUPLENTE',
      ].includes(cargoDeliberativo)
    )
      return [];

    return allOptions;
  };

  const getFilteredCargoDeliberativoOptions = () => {
    const { cargoDiretoria, sexo, cargoFiscal } = formData;
    if (cargoFiscal) return [];

    const allOptions = getCargoDeliberativoOptions();

    if (cargoDiretoria === 'PRESIDENTE')
      return allOptions.filter(opt => opt.value === 'PRESIDENTE');
    if (cargoDiretoria === (sexo === 'FEMININO' ? 'SECRETÁRIA' : 'SECRETÁRIO'))
      return allOptions.filter(
        opt => opt.value === (sexo === 'FEMININO' ? 'SECRETÁRIA' : 'SECRETÁRIO')
      );
    if (
      ['VICE_PRESIDENTE', 'TESOUREIRO', 'TESOUREIRA'].includes(cargoDiretoria)
    )
      return [];

    return allOptions;
  };

  const getFilteredCargoFiscalOptions = () => {
    const { cargoDiretoria, cargoDeliberativo } = formData;
    if (cargoDiretoria || cargoDeliberativo) return [];
    return getCargoFiscalOptions();
  };

  const handleSubmit = e => {
    e.preventDefault();

    const camposObrigatorios = [
      { campo: 'cpf', label: 'CPF' },
      { campo: 'nome', label: 'Nome' },
      { campo: 'sexo', label: 'Sexo' },
      { campo: 'estadoCivil', label: 'Estado Civil' },
      { campo: 'nacionalidade', label: 'Nacionalidade' },
      { campo: 'rgNum', label: 'Nº RG' },
      { campo: 'rgEmissor', label: 'Emissor RG' },
      { campo: 'rgDataEmissao', label: 'Data Emissão RG' },
      { campo: 'rgUf', label: 'UF RG' },
      { campo: 'logrNome', label: 'Logradouro Nome' },
      { campo: 'logrNum', label: 'Número' },
      { campo: 'logrCompl', label: 'Complemento' },
      { campo: 'logrBairro', label: 'Bairro' },
      { campo: 'logrUf', label: 'UF' },
      { campo: 'logrCidade', label: 'Cidade' },
      { campo: 'logrCep', label: 'CEP' },
      { campo: 'profissao', label: 'Profissão / Ocupação' },
    ];
    const faltando = camposObrigatorios.find(c => {
      const v = formData[c.campo];
      return v === undefined || v === null || String(v).trim() === '';
    });
    if (faltando) {
      showDefaultModal('error', `O campo "${faltando.label}" é obrigatório.`);
      return;
    }

    if (!isValidCPF(formData.cpf)) {
      // setCpfError('CPF inválido');
      showDefaultModal('error', 'CPF inválido');
      return;
    }
    // setCpfError('');

    const dataToSave = {
      ...formData,
      cpf: unformatCPF(formData.cpf),
      logrCep: unformatCEP(formData.logrCep),
      celular: unformatCelular(formData.celular),
    };
    axios
      .post(`${API_BASE_URL.PESSOA}/save`, dataToSave, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(result => {
        showDefaultModal('success', 'Registro salvo com sucesso!', () =>
          navigate('/pessoas')
        );
      })
      .catch(error => {
        console.error('Erro ao salvar formData:', error);
      });
  };

  return (
    <Layout>
      <ResponsiveShadow>
        <PageHeader title="Cadastro de Pessoa" icon="bi-person" closeRoute="/pessoas" />
        <PageContent>
          <form id="pessoa-form" onSubmit={handleSubmit}>
              {/* 
                SEU FORMULÁRIO GIGANTE FICA AQUI DENTRO, INTACTO
              */}
              <div className="row g-3 small">
                {/* CPF */}
                <div className="col-12 col-sm-6 col-md-2 input-group-sm">
                  <label htmlFor="cpf" className="form-label">
                    CPF
                  </label>
                  <CPFMaskInput
                    id="cpf"
                    value={formatCPF(formData.cpf)}
                    onChange={e =>
                      handleChange({
                        target: {
                          name: 'cpf',
                          value: unformatCPF(e.target.value),
                        },
                      })
                    }
                    name="cpf"
                    type="text"
                    required
                  />
                  {cpfError && (
                    <small className="text-danger">{cpfError}</small>
                  )}
                </div>
                {/* Nome */}
                <div className="col-12 col-sm-6 col-md-6 input-group-sm">
                  <label htmlFor="nome" className="form-label">
                    Nome
                  </label>
                  <input
                    type="text"
                    className="form-control text-uppercase"
                    id="nome"
                    name="nome"
                    value={formData.nome}
                    onChange={handleChange}
                    required
                  />
                </div>
                {/* Sexo */}
                <div className="col-12 col-sm-6 col-md-2 input-group-sm">
                  <label htmlFor="sexo" className="form-label">
                    Sexo
                  </label>
                  <select
                    className="form-control"
                    name="sexo"
                    value={formData.sexo}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Selecione...</option>
                    <option value="FEMININO">FEMININO</option>
                    <option value="MASCULINO">MASCULINO</option>
                  </select>
                </div>

                {/* Estado Civil */}
                <div className="col-12 col-sm-6 col-md-2 input-group-sm">
                  <label htmlFor="estadoCivil" className="form-label">
                    Estado Civil
                  </label>
                  <select
                    className="form-control"
                    name="estadoCivil"
                    value={formData.estadoCivil}
                    onChange={handleChange}
                    disabled={!formData.sexo}
                    required
                  >
                    <option value="">Selecione...</option>
                    {formData.sexo &&
                      getEstadoCivilOptions().map((option, index) => (
                        <option key={index} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                  </select>
                </div>

                {/* Nacionalidade */}
                <div className="col-12 col-sm-6 col-md-2 input-group-sm">
                  <label htmlFor="nacionalidade" className="form-label">
                    Nacionalidade
                  </label>
                  <select
                    className="form-control"
                    name="nacionalidade"
                    value={formData.nacionalidade}
                    onChange={handleChange}
                    disabled={!formData.sexo}
                    required
                  >
                    <option value="">Selecione...</option>
                    {formData.sexo &&
                      getNacionalidadeOptions().map((option, index) => (
                        <option key={index} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                  </select>
                </div>

                {/* RG */}
                <div className="col-12 col-sm-6 col-md-2 input-group-sm">
                  <label htmlFor="rgNum" className="form-label">
                    Nº RG
                  </label>
                  <input
                    type="text"
                    className="form-control text-uppercase"
                    id="rgNum"
                    name="rgNum"
                    value={formData.rgNum}
                    onChange={handleChange}
                    required
                  />
                </div>

                {/* EMISSOR */}
                <div className="col-12 col-sm-6 col-md-1 input-group-sm">
                  <label htmlFor="rgEmissor" className="form-label">
                    Emissor RG
                  </label>
                  <select
                    id="rgEmissor"
                    className="form-control small"
                    value={formData.rgEmissor}
                    onChange={handleChange}
                    name="rgEmissor"
                    required
                  >
                    <option value="">Selecione...</option>
                    {emissor.map((e, index) => (
                      <option key={index} value={e.codigo}>
                        {e.codigo}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Data Emissão RG */}
                <div className="col-12 col-sm-6 col-md-2 input-group-sm">
                  <label htmlFor="rgDataEmissao" className="form-label">
                    Data Emissão RG
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    id="rgDataEmissao"
                    name="rgDataEmissao"
                    value={formData.rgDataEmissao}
                    onChange={handleChange}
                    required
                  />
                </div>

                {/* RG UF */}
                <div className="col-12 col-sm-6 col-md-1 input-group-sm">
                  <label htmlFor="rgUf" className="form-label">
                    UF RG
                  </label>
                  <select
                    id="rgUf"
                    className="form-control small"
                    value={formData.rgUf}
                    onChange={handleChange}
                    name="rgUf"
                    required
                  >
                    <option value="">Selecione...</option>
                    {ufRg.map((e, index) => (
                      <option key={index} value={e.sigla}>
                        {e.sigla}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Logradouro */}
                <div className="col-12 col-sm-6 col-md-4 input-group-sm">
                  <label htmlFor="logrNome" className="form-label">
                    Logradouro Nome
                  </label>
                  <input
                    type="text"
                    className="form-control text-uppercase"
                    id="logrNome"
                    name="logrNome"
                    value={formData.logrNome}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="col-12 col-sm-6 col-md-1 input-group-sm">
                  <label htmlFor="logrNum" className="form-label">
                    Número
                  </label>
                  <input
                    type="text"
                    className="form-control text-uppercase"
                    id="logrNum"
                    name="logrNum"
                    value={formData.logrNum}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="col-12 col-sm-6 col-md-2 input-group-sm">
                  <label htmlFor="logrCompl" className="form-label">
                    Complemento
                  </label>
                  <input
                    type="text"
                    className="form-control text-uppercase"
                    id="logrCompl"
                    name="logrCompl"
                    value={formData.logrCompl}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="col-12 col-sm-6 col-md-3 input-group-sm">
                  <label htmlFor="logrBairro" className="form-label">
                    Bairro
                  </label>
                  <input
                    type="text"
                    className="form-control text-uppercase"
                    id="logrBairro"
                    name="logrBairro"
                    value={formData.logrBairro}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="col-12 col-sm-6 col-md-1 input-group-sm">
                  <label className="form-label">UF</label>
                  <select
                    className="form-control small"
                    value={formData.logrUf}
                    onChange={handleChange}
                    name="logrUf"
                    required
                  >
                    <option value="">Selecione uma UF...</option>
                    {ufs.map((uf, index) => (
                      <option key={index} value={uf.sigla}>
                        {uf.sigla}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-12 col-sm-6 col-md-3 input-group-sm">
                  <label className="form-label">Cidade</label>
                  <select
                    className="form-control"
                    value={formData.logrCidade}
                    onChange={handleChange}
                    name="logrCidade"
                    disabled={!formData.logrUf}
                    required
                  >
                    <option value="">Selecione uma cidade...</option>
                    {cidades.map((cidade, index) => (
                      <option key={index} value={cidade.nome}>
                        {cidade.nome}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-12 col-sm-6 col-md-2 input-group-sm">
                  <label className="form-label">CEP</label>
                  <CEPMaskInput
                    value={formatCEP(formData.logrCep)}
                    onChange={e =>
                      handleChange({
                        target: {
                          name: 'logrCep',
                          value: unformatCEP(e.target.value),
                        },
                      })
                    }
                    name="logrCep"
                    ref={el => (refs.current.cep = el)}
                    type="text"
                    required
                  />
                </div>

                <div className="col-12 col-sm-6 col-md-4 input-group-sm">
                  <label htmlFor="profissao" className="form-label">
                    Profissão / Ocupação
                  </label>
                  <input
                    type="text"
                    className="form-control text-uppercase"
                    id="profissao"
                    name="profissao"
                    value={formData.profissao}
                    onChange={handleChange}
                    required
                  />
                </div>

                {/* Celular */}
                <div className="col-12 col-sm-6 col-md-2 input-group-sm">
                  <label htmlFor="celular" className="form-label">
                    Celular
                  </label>
                  <CelularMaskInput
                    value={formatCelular(formData.celular)}
                    onChange={e =>
                      handleChange({
                        target: {
                          name: 'celular',
                          value: unformatCelular(e.target.value),
                        },
                      })
                    }
                    name="celular"
                    id="celular"
                  />
                </div>

                {/* Email */}
                <div className="col-12 col-sm-6 col-md-6 input-group-sm">
                  <label htmlFor="email" className="form-label">
                    Email
                  </label>
                  <input
                    type="email"
                    className="form-control"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="email@exemplo.com"
                  />
                </div>

                <div className="col-12 "></div>
                {/* Cargo Diretoria */}
                <div className="col-12 col-sm-6 col-md-4 input-group-sm">
                  <label htmlFor="cargoDiretoria" className="form-label">
                    Cargo Diretoria
                  </label>
                  <select
                    className="form-control"
                    name="cargoDiretoria"
                    id="cargoDiretoria"
                    value={formData.cargoDiretoria}
                    onChange={handleChange}
                    disabled={
                      !formData.sexo ||
                      (getFilteredCargoDiretoriaOptions().length === 0 &&
                        !formData.cargoDiretoria)
                    }
                  >
                    <option value="">Selecione...</option>
                    {getFilteredCargoDiretoriaOptions().map((option, index) => (
                      <option key={index} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Cargo Deliberativo */}
                <div className="col-12 col-sm-6 col-md-4 input-group-sm">
                  <label htmlFor="cargoDeliberativo" className="form-label">
                    Cargo Deliberativo
                  </label>
                  <select
                    className="form-control"
                    name="cargoDeliberativo"
                    id="cargoDeliberativo"
                    value={formData.cargoDeliberativo}
                    onChange={handleChange}
                    disabled={
                      !formData.sexo ||
                      (getFilteredCargoDeliberativoOptions().length === 0 &&
                        !formData.cargoDeliberativo)
                    }
                  >
                    <option value="">Selecione...</option>
                    {getFilteredCargoDeliberativoOptions().map(
                      (option, index) => (
                        <option key={index} value={option.value}>
                          {option.label}
                        </option>
                      )
                    )}
                  </select>
                </div>

                {/* Cargo Fiscal */}
                <div className="col-12 col-sm-6 col-md-4 input-group-sm">
                  <label htmlFor="cargoFiscal" className="form-label">
                    Cargo Fiscal
                  </label>
                  <select
                    className="form-control"
                    name="cargoFiscal"
                    id="cargoFiscal"
                    value={formData.cargoFiscal}
                    onChange={handleChange}
                    disabled={
                      getFilteredCargoFiscalOptions().length === 0 &&
                      !formData.cargoFiscal
                    }
                  >
                    <option value="">Selecione...</option>
                    {getFilteredCargoFiscalOptions().map((option, index) => (
                      <option key={index} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </form>
        </PageContent>
        
        <div style={{
          padding: '1rem',
          borderTop: '1px solid rgba(0,0,0,0.1)',
          display: 'flex',
          gap: '0.5rem',
          backgroundColor: '#f8f9fa'
        }}>
          <button
            type="submit"
            form="pessoa-form"
            className="btn btn-success btn-sm"
          >
            Salvar
          </button>
          <Link
            className="btn btn-secondary btn-sm"
            to="/pessoas"
          >
            Cancelar
          </Link>
        </div>
      </ResponsiveShadow>

      <DefaultModal {...setDefaultModal} />
    </Layout>
  );
};

export default Pessoa;
